import React, { useState } from "react";

const views = [
  {
    key: "disbursal",
    label: "Disbursal & Collection",
    icon: (
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
  {
    key: "financial",
    label: "Financial Summary",
    icon: (
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
        <polyline points="17 6 23 6 23 12" />
      </svg>
    ),
  },
  {
    key: "funnel",
    label: "Funnel Visualization",
    icon: (
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
      </svg>
    ),
  },
  {
    key: "emi",
    label: "EMI Behavior",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-chart-column-icon lucide-chart-column"
      >
        <path d="M3 3v16a2 2 0 0 0 2 2h16" />
        <path d="M18 17V9" />
        <path d="M13 17V5" />
        <path d="M8 17v-3" />
      </svg>
    ),
  },
    {
    key: "actualVsProfit",
    label: "Actual vs Profit",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-bar-chart"
      >
        <line x1="12" y1="2" x2="12" y2="22" />
        <path d="M17 5H9.5a1.5 1.5 0 0 0-1.5 1.5v12" />
        <path d="M3 21h18" />
      </svg>
    ),
  },
  // {
  //   key: "projection",
  //   label: "Projection vs Actual",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       stroke-width="2"
  //       stroke-linecap="round"
  //       stroke-linejoin="round"
  //       class="lucide lucide-calendar-icon lucide-calendar"
  //     >
  //       <path d="M8 2v4" />
  //       <path d="M16 2v4" />
  //       <rect width="18" height="18" x="3" y="4" rx="2" />
  //       <path d="M3 10h18" />
  //     </svg>
  //   ),
  // },
];

export default function MISnavbar({ onSelect }) {
  const [selected, setSelected] = useState("disbursal");

  const handleSelect = (key) => {
    setSelected(key);
    if (onSelect) onSelect(key);
  };

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "16px",
        padding: "24px 28px",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <h2
        style={{
          margin: "0 0 20px 0",
          fontSize: "17px",
          fontWeight: "500",
          color: "#1e293b",
        }}
      >
        Select Dashboard View
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${views?.length}, 1fr)`,
          gap: "12px",
        }}
      >
        {views.map((view) => {
          const isSelected = selected === view.key;
          return (
            <button
              key={view.key}
              onClick={() => handleSelect(view.key)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                padding: "20px 12px",
                borderRadius: "12px",
                border: isSelected ? "none" : "1px solid #e2e8f0",
                backgroundColor: isSelected ? "#155DFC" : "#ffffff",
                color: isSelected ? "#ffffff" : "#1e293b",
                fontSize: "14px",
                fontWeight: isSelected ? "600" : "500",
                cursor: "pointer",
                textAlign: "center",
                lineHeight: "1.3",
                transition: "all 0.15s ease",
                minHeight: "110px",
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = "#f8fafc";
                  e.currentTarget.style.borderColor = "#cbd5e1";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = "#ffffff";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }
              }}
            >
              <span style={{ opacity: isSelected ? 1 : 0.75 }}>
                {view.icon}
              </span>
              <span>{view.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
